// Build identifier compiled into this bundle. See docs/stale-detection.md.
export const LOCAL_BUILD_ID = 'local';

export const BUILD_ID = process.env.REACT_APP_BUILD_ID || LOCAL_BUILD_ID;

export const isLocalBuild = BUILD_ID === LOCAL_BUILD_ID;
